module.exports = __webpack_public_path__ + "static/media/HomeChildVaccination.7ba6a889.svg";